import type { PixelIconName } from '../types/window';

interface PixelIconProps {
  name: PixelIconName;
  size?: number;
  class?: string;
}

export function PixelIcon(props: PixelIconProps) {
  const size = () => props.size ?? 32;

  const artwork = () => {
    switch (props.name) {
      case 'computer':
        return (
          <>
            <rect x="3" y="3" width="24" height="18" fill="#c0c0c0" stroke="#000" />
            <rect x="6" y="6" width="18" height="12" fill="#000080" />
            <rect x="11" y="22" width="8" height="3" fill="#808080" stroke="#000" />
            <rect x="7" y="26" width="16" height="3" fill="#c0c0c0" stroke="#000" />
          </>
        );
      case 'folder':
        return (
          <>
            <path d="M2 8h11l3 3h14v17H2z" fill="#f5d85b" stroke="#000" />
            <path d="M2 8V5h11l3 3" fill="#fff099" stroke="#000" />
            <path d="M4 13h24" stroke="#8a6b00" />
          </>
        );
      case 'document':
        return (
          <>
            <path d="M7 2h13l7 7v21H7z" fill="#fff" stroke="#000" />
            <path d="M20 2v8h7" fill="#c0c0c0" stroke="#000" />
            <path d="M11 15h12M11 19h12M11 23h9" stroke="#000080" />
          </>
        );
      case 'info':
        return (
          <>
            <circle cx="16" cy="16" r="13" fill="#fff" stroke="#000" />
            <circle cx="16" cy="16" r="10" fill="#000080" />
            <rect x="15" y="13" width="3" height="10" fill="#fff" />
            <rect x="15" y="8" width="3" height="3" fill="#fff" />
          </>
        );
      case 'network':
        return (
          <>
            <circle cx="16" cy="14" r="11" fill="#4aa3df" stroke="#000" />
            <path d="M5 14h22M16 3c-5 5-5 17 0 22M16 3c5 5 5 17 0 22" fill="none" stroke="#fff" />
            <rect x="3" y="25" width="9" height="5" fill="#c0c0c0" stroke="#000" />
            <rect x="20" y="25" width="9" height="5" fill="#c0c0c0" stroke="#000" />
            <path d="M8 25v-3h16v3" fill="none" stroke="#000" />
          </>
        );
      case 'project':
        return (
          <>
            <rect x="3" y="5" width="26" height="23" fill="#c0c0c0" stroke="#000" />
            <rect x="6" y="8" width="20" height="14" fill="#fff" stroke="#808080" />
            <path d="M7 20l5-6 4 3 4-7 5 10" fill="none" stroke="#000080" />
            <rect x="7" y="24" width="7" height="2" fill="#808080" />
          </>
        );
      case 'raytracer':
        return (
          <>
            <rect x="2" y="3" width="28" height="26" fill="#101833" stroke="#000" />
            <circle cx="12" cy="17" r="7" fill="#d74747" />
            <circle cx="21" cy="12" r="6" fill="#4a72dd" />
            <circle cx="10" cy="14" r="2" fill="#fff" />
            <circle cx="19" cy="10" r="2" fill="#fff" />
            <path d="M2 26l28-15" stroke="#f5d85b" />
          </>
        );
      case 'recycle':
        return (
          <>
            <rect x="8" y="8" width="17" height="21" fill="#e8e8e8" stroke="#000" />
            <rect x="6" y="5" width="21" height="4" fill="#c0c0c0" stroke="#000" />
            <rect x="12" y="2" width="9" height="3" fill="#c0c0c0" stroke="#000" />
            <path d="M12 12v13M16 12v13M21 12v13" stroke="#008080" />
          </>
        );
      case 'settings':
        return (
          <>
            <rect x="4" y="5" width="24" height="22" fill="#c0c0c0" stroke="#000" />
            <rect x="7" y="8" width="18" height="12" fill="#fff" stroke="#808080" />
            <rect x="9" y="10" width="5" height="4" fill="#000080" />
            <rect x="15" y="10" width="4" height="4" fill="#008080" />
            <rect x="20" y="10" width="3" height="4" fill="#800080" />
            <rect x="9" y="15" width="14" height="3" fill="#f5d85b" />
            <circle cx="11" cy="24" r="2" fill="#000" />
            <circle cx="21" cy="24" r="2" fill="#000" />
          </>
        );
      case 'shutdown':
        return (
          <>
            <circle cx="16" cy="17" r="12" fill="#c0c0c0" stroke="#000" />
            <path d="M16 5v12" stroke="#d00000" stroke-width="4" />
            <path d="M10 10a9 9 0 1 0 12 0" fill="none" stroke="#d00000" stroke-width="3" />
          </>
        );
      case 'github':
        return (
          <>
            <rect x="3" y="3" width="26" height="26" rx="2" fill="#fff" stroke="#000" />
            <text x="16" y="21" text-anchor="middle" font-size="13" font-family="Arial" font-weight="bold">GH</text>
          </>
        );
      case 'linkedin':
        return (
          <>
            <rect x="3" y="3" width="26" height="26" fill="#0a66c2" stroke="#000" />
            <text x="16" y="22" text-anchor="middle" font-size="16" font-family="Arial" font-weight="bold" fill="#fff">in</text>
          </>
        );
      case 'x':
        return (
          <>
            <rect x="3" y="3" width="26" height="26" fill="#050505" stroke="#000" />
            <path d="M9 8l14 16M22 8L10 24" fill="none" stroke="#fff" stroke-width="2.4" />
          </>
        );
      case 'instagram':
        return (
          <>
            <rect x="3" y="3" width="26" height="26" rx="5" fill="#c13584" stroke="#000" />
            <path d="M3 22L22 3h7v26H3z" fill="#f77737" opacity="0.82" />
            <rect x="9" y="9" width="14" height="14" rx="4" fill="none" stroke="#fff" stroke-width="2" />
            <circle cx="16" cy="16" r="4" fill="none" stroke="#fff" stroke-width="2" />
            <rect x="21" y="10" width="2" height="2" fill="#fff" />
          </>
        );
      case 'facebook':
        return (
          <>
            <rect x="3" y="3" width="26" height="26" fill="#1877f2" stroke="#000" />
            <text x="16" y="25" text-anchor="middle" font-size="25" font-family="Arial" font-weight="bold" fill="#fff">f</text>
          </>
        );
      case 'stackoverflow':
        return (
          <>
            <rect x="5" y="21" width="22" height="8" fill="#fff" stroke="#000" />
            <path d="M10 23h13M11 19l13 2M12 15l12 4M15 10l10 7M20 5l7 10" fill="none" stroke="#f48024" stroke-width="2" />
          </>
        );
      case 'warning':
        return (
          <>
            <path d="M16 2L30 29H2z" fill="#f5d85b" stroke="#000" />
            <rect x="15" y="10" width="3" height="10" fill="#000" />
            <rect x="15" y="23" width="3" height="3" fill="#000" />
          </>
        );
    }
  };

  return (
    <svg
      class={props.class}
      width={size()}
      height={size()}
      viewBox="0 0 32 32"
      role="img"
      aria-hidden="true"
      shape-rendering="crispEdges"
    >
      {artwork()}
    </svg>
  );
}
